import { Adicional } from "../Emisor/Adicional";
import { CertificacionPrecio } from "./CertificacionPrecio";

export class DatosFacturacion {
	public idPlanSf: string;
	public idPlanUsuario: string;
	public nombrePlan: string;
	public tipoCertificacion: string;
	public certificaciones: CertificacionPrecio[];
	public adicionales: Adicional[];
	public formaPago: string;
	public meses: number;
	public total: number;
	public idContratacion: string;
	public idDatoFacturacion: string;
	public empresaFacturacion: EmpresaFacturacion;
	public pagado: boolean;
	public codigoCupon: string;
	public origen: string;
	public FechaConfirmacionCertificaciones?: Date;

	/**
	 *
	 */
	constructor() {
		this.empresaFacturacion = new EmpresaFacturacion();
	}
}

export class EmpresaFacturacion {
	public emisorDatosId: string;
	public emisorId: string;
	public rutString: string;
	public rut: number;
	public dv: string;
	public razonSocial: string;
	public correoFact: string;
	public giro: string;
	public dirFact: string;
	public comuna: string;
	public telefono: string;
}
